export class Folder {
	id: string
	name: string
	access: any
	branding: any
	date: any
	updated: any
	created_by: any
	activity: any
	parents: Array<any>
	folders: any
	files: any
	subject: any
	customURL: string
	settings: any
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder.ts